﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as bootstrap_switch from 'bootstrap-switch';

import tpl_officePowerPoint from './tpl/officePowerPoint.html';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';


import View_Module from './module';

import View_ModuleItem from './moduleItem';

export default View_ModuleItem.extend({

    getTemplate: function () {
        return tpl_officePowerPoint();
    },
    regions: {
        'modal': '#modal'
    },
    playLive: function () {
    },
    initialize: function () {
        self = this;
        this.app = this.options.app;

        this.listenTo(this.model, 'setupSetting', this.setupSetting, this);

        this.listenTo(this.model, 'change', this.render, this);

        var userChannel = Backbone.Radio.channel('app');

        this.listenTo(userChannel, 'officePowerPoint:play', function (/*parent, */moduleDiv, moduleRegion) {
            if (this.model.attributes.ModuleDiv == moduleDiv && this.model.attributes.ModuleRegion == moduleRegion) {
                //if (this._parent.$el == parent._parent.$el) {
                switch (this.model.attributes.Play) {
                    case 1: this.play(); break;
                    case 0: this.pause(); break;
                }
            }
        });
    },
    ui: {
        'setting_margin': '#setting_margin',
        'module_margin': '#module_margin',
        'officePowerPoint_officePowerPoint': '#officePowerPoint_officePowerPoint'
    },
    events: {
    },
    onRender: function () {
        this.setupSetting();
    },
    setupSetting() {
        this.setupMargin();
        this.setupStyle();
    },
    onAttach() {
        this.setupSetting();
    },
    setupStyle() {
        var src = String.format(this.model.attributes.Data.Url, this.model.attributes.Data.InfoFile_FileUrl);
        this.ui.officePowerPoint_officePowerPoint.attr('src', src);
        //this.ui.officePowerPoint_officePowerPoint.attr('src', this.model.attributes.Data.VideoId);
    },
    play: function () {
        //const iframe = document.getElementById("officePowerPoint_officePowerPoint");
        //const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        ////const iframeDoc = this.ui.officePowerPoint_officePowerPoint.contentDocument || this.ui.officePowerPoint_officePowerPoint.contentWindow.document;
        //const buttonInsideIframe = iframeDoc.getElementById("ButtonFastFwd-Small14");
        //if (buttonInsideIframe) {
        //    buttonInsideIframe.click();
        //}
        //$('#ButtonFastFwd-Small14').click();
        //var self = this;
        //this.current = this.model.attributes.Data.StartPage - 1;

        //this.nextTemplate();

        this.nextTemplate();
    },
    pause: function () {
        //const iframeDoc = this.ui.officePowerPoint_officePowerPoint.contentDocument || this.ui.officePowerPoint_officePowerPoint.contentWindow.document;
        //const buttonInsideIframe = iframeDoc.getElementById("Small14-Small14");
        //if (buttonInsideIframe) {
        //    buttonInsideIframe.click();
        //}
        //$('#ButtonFastBack-Small14').click();
        //if (this.timeoutId) {
        //    clearTimeout(this.timeoutId);
        //}

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    },
    nextTemplate: function () {
        var self = this;

        if (this.timeoutId) {
            clearTimeout(self.timeoutId);
            if (this.model.attributes.Data.EnablePlay) {
                this.setupStyle();
            }
        }

        if (this.model.attributes.Data.EnablePlay) {
            this.timeoutId = setInterval(function () {
                self.nextTemplate();
            }, this.model.attributes.Data.Duration * 1000);
        }
    },
    myDestroy: function () {
    },
}, Backbone.Radio.Requests);
